import { SAVE_RISK_TRANSLATION } from "../constants";

export const defaultState = {
  risksTranslations: {},
};

export default (state = defaultState, action) => {
  const { type } = action;
  const newState = { ...state };

  switch (type) {
    case SAVE_RISK_TRANSLATION:
      if (!newState.risksTranslations[action.row.id]) {
        newState.risksTranslations[action.row.id] = {};
      }
      const riskTranslation = newState.risksTranslations[action.row.id];
      riskTranslation[action.language] = { row: action.row, translation: action.translation };
      return newState;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/translations.js